module.exports = __webpack_public_path__ + "static/media/VidhuPVinod.eb3e1e44.jpg";